import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Drawer} from "@mui/material";

import Toggle from "components/Toggle/Toggle";

import SelectedFilters from "../../Filter/SelectedFilters";
import FilterElements from "../../Filter/FilterElements";

import {OrderListContext} from "../../../context/OrderListContext";

import {greyishBlue50, greyishBlue100} from "assets/jss/main";

FiltersDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

function FiltersDrawer({open, onClose}) {
    const {filterMenuSelected, setFilterMenuSelected, filters, selectedFilters, setSelectedFilters} = useContext(OrderListContext);

    function handleRemoveFilter(filter) {
        setSelectedFilters(selectedFilters.filter((selectedFilter) => selectedFilter.id !== filter.id));
    }

    return (
        <Drawer anchor="bottom" open={open} onClose={onClose}>
            <div style={{display: 'flex', flexDirection: 'column', gap: '16px', padding: '16px', maxHeight: '80vh', overflowY: 'auto'}}>
                <span style={{fontWeight: 600, fontSize: '16px'}}>
                    <FormattedMessage id='retailer.product.list.filter.title' />
                </span>

                {/* same look as ToggleNavigation, but scrollable instead of
                    shrinking the category labels when they overflow the drawer's width */}
                <div style={{
                    display: 'flex',
                    overflowX: 'auto',
                    background: greyishBlue50,
                    border: `1px solid ${greyishBlue100}`,
                    borderRadius: '10px',
                    padding: '2px'
                }}>
                    {Object.keys(filters).map((name) => (
                        <div key={name} style={{flexShrink: 0}}>
                            <Toggle
                                label={<FormattedMessage id={"retailer.product.list.filter." + name.toLowerCase()} />}
                                checked={filterMenuSelected === name}
                                onClick={() => setFilterMenuSelected(name)}
                            />
                        </div>
                    ))}
                </div>

                <FilterElements />

                <SelectedFilters
                    selectedFilters={selectedFilters}
                    onRemove={handleRemoveFilter}
                />
            </div>
        </Drawer>
    );
}

export default FiltersDrawer;
